import c from './styles.module.scss'

const TextBlock = ({children}) => {
    return (
        <div className={c.textBlock}>{children}</div>
    )
}

export default TextBlock